import { IThoiKhoaBieuItemSelectRequest } from "../models/request/thoi-khoa-bieu/IThoiKhoaBieuItemSelectRequest";
import { IMeetingVm } from "../models/response/meeting/IMeetingVm";
import { apiClient } from "./apiClient";

export const meetingApi = {
    saveChange: (payload: IMeetingVm) => apiClient.post('meeting', payload),
    select: (id: number, nam_hoc: string) => apiClient.get("meeting/truong/" + id.toString() + "/nam-hoc/" + nam_hoc),
    // selectByGiaoVien: (id: number, nam_hoc: string, gvid: number) => apiClient.get("meeting/truong/" + id.toString() + "/nam-hoc/" + nam_hoc + "/giao-vien/" + gvid.toString()),
    selectDetail: (id: number) => apiClient.get("meeting/" + id.toString()),
    selectRegisterResult: (id: number) => apiClient.get("meeting/" + id.toString() +"/history"),
    delete: (id: number) => apiClient.delete("meeting/" + id.toString()),
    sendNotify: (id: number) => apiClient.post("meeting/" + id.toString()+'/notify'),
    getTkbByTeacher: (rq: IThoiKhoaBieuItemSelectRequest) => apiClient.post("meeting/tkb-gv", rq)
}